module.exports = "<p>\n  edit-template-metrics works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/template-metrics/edit-template-metrics/edit-template-metrics.component.html
// module id = ../../../../../src/app/template-metrics/edit-template-metrics/edit-template-metrics.component.html
// module chunks = main